<template>
  <div>
    <h1>Cuentas Bancarias</h1>
    <List :items="bankaccounts" :columns="columns" />
  </div>
</template>

<script>
import List from "@/components/gotrading/common/List.vue";
import { wencesApi } from "@/api/wencesApi";

export default {
  name: "BankAccountsPage",
  components: { List },
  data() {
    return {
      bankaccounts: [],
      columns: [
        { key: "bankName", label: "Banco" },
        { key: "accountNumber", label: "N° de Cuenta" },
        { key: "iban", label: "IBAN" },
        { key: "swift", label: "SWIFT" },
        { key: "holder", label: "Titular" },
      ],
    };
  },
  async mounted() {
    try {
      const response = await wencesApi.get("/api/gotrading/bank-accounts");
      this.bankaccounts = response.data;
    } catch (error) {
      console.error("Error al obtener cuentas bancarias:", error);
    }
  },
};
</script>
